import React, { useState, useEffect } from 'react';
import CreatePost from './CreatePost';
import { UseAuthContext } from '../../../context/AuthContext';
import { onValue, query, orderByChild, off } from "firebase/database";
import { postListRef } from '../../../firebase';
import ViewPost from './ViewPost';

function NewsFeed() {
    const { user } = UseAuthContext();
    const [loading, setLoading] = useState(false);
    const [posts, setPosts] = useState([]);
    const [modalValue,setModalValue]=useState();

    useEffect(() => {
        setLoading(true);
        let ref = query(postListRef, orderByChild('lastUpdated'));
        onValue(ref, (snapshot) => {
            let data = [];
            snapshot.forEach((childSnapshot) => {
                const childKey = childSnapshot.key;
                const childData = childSnapshot.val();
                data.push({ key: childKey, val: childData });
                setModalValue(pre=>pre && pre.key===childKey?
                    ({key:childKey,val:childData}):
                    ({...pre}));
            });
            
            setPosts(data.reverse());
            setLoading(false);
        });
        return () => off(ref);
    }, [])

    return (
        <section id="team" className="team px-3" >
            <ViewPost post={modalValue} user={user}/>
            {user?.id && <CreatePost user={user} />}
                <div className="section-title">
                    <p>News Feeds</p>
                </div>
                <div className="row g-2 p-1">
                    {loading && <><h2>Loading</h2>
                        <div className="d-flex justify-content-center" style={{ color: "#eb5d1e" }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div></>}

                    {!loading && posts.length > 0 ? posts.map((p, index) => <div key={index} className="col-sm-3 col-6" data-aos="zoom-in-up" data-aos-delay={100}>
                        <div className="card" >
                            <div className="card-body">
                                <div className="text-center">
                                    <div id={`postCarousel_${index}`} className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            {(p.val.imgSrc && p.val.imgSrc.length > 0) ? <>
                                                {p.val.imgSrc.map((pSrc, index) => <div key={index} className={index===0?"carousel-item active":"carousel-item"} >
                                                    <img src={pSrc} className="d-block w-100" alt="..." style={{ height: "200px",color:"#fff" }} />
                                                </div>)}
                                                {p.val.post && <div className="carousel-item post-text ">
                                                    <i className="text-wrap fs-4 text-truncate" style={{ whiteSpace: "pre-line" }}>{p.val.post}</i>
                                                </div>}
                                            </> : <div className="carousel-item post-text active" >
                                                <i className="text-wrap fs-4 text-truncate" style={{ whiteSpace: "pre-line" }}>{p.val.post}</i>
                                            </div>}
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target={`#postCarousel_${index}`} data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true" />
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target={`#postCarousel_${index}`} data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true" />
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="card-info-content" style={{cursor:"pointer"}} 
                                data-bs-toggle="modal" data-bs-target="#viewPost"
                                onClick={()=>setModalValue(p)}>
                                    <h4>{p.val.userName}</h4>
                                    <span>{p.val.created}</span>
                                    <span>Comment: {p.val.comment ? p.val.comment.length : 0}</span>
                                </div>
                            </div>
                        </div>
                    </div>) : !loading && <h2>Create new post</h2>}
                </div>
        </section >
    )
}
export default React.memo(NewsFeed);